// 使用flv.js的视频播放器
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import warning from '@/common/img/video/warning.svg';
import airportWarning from '@/common/img/video/airportWarning.svg';
import { Button, theme } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import flvjs from 'flv.js'

function FlvVideo (props) {


  let videoElementRef = useRef(null)//
  let flvPlayerRef = useRef(null)//
  let lastDecodedFramesRef = useRef(null)//
  let addressRef = useRef(props.liveUrl)
  let countNum = useRef(0)//计数 请求一定次数后再销毁

  const init = () => {
    // Check if the browser supports FLV.js
    if (flvjs.isSupported()) {
      videoElementRef.current = document.getElementById('videoElementRef.current');
      console.log('当前直播地址', addressRef.current);
      flvPlayerRef.current = flvjs.createPlayer({
        type: 'flv',
        isLive: true,
        hasAudio: false,
        url: addressRef.current,  // Replace with your FLV video URL

        enableWorker: false, //启用 Web Worker 进程来加速视频的解码和处理过程
        enableStashBuffer: false, // 启用数据缓存机制，提高视频的流畅度和稳定性。
        stashInitialSize: 32 * 1024, // 初始缓存大小。单位：字节。建议针对直播：调整为1024kb
        stashInitialTime: 0.2, // 缓存初始时间。单位：秒。建议针对直播：调整为200毫秒
        seekType: 'range', // 建议将其设置为“range”模式，以便更快地加载视频数据，提高视频的实时性。
        lazyLoad: false, //关闭懒加载模式，从而提高视频的实时性。建议针对直播：调整为false
        lazyLoadMaxDuration: 0.2, // 懒加载的最大时长。单位：秒。建议针对直播：调整为200毫秒
        deferLoadAfterSourceOpen: false, // 不预先加载视频数据，在 MSE（Media Source Extensions）打开后立即加载数据，提高视频的实时性。建议针对直播：调整为false

        config: { autoCleanupSourceBuffer: true }
      });
      flvPlayerRef.current.attachMediaElement(videoElementRef.current);
      flvPlayerRef.current.load();
      flvPlayerRef.current.play();
      console.log('开始播放')

      videoElementRef.current?.addEventListener("progress", () => {
        if (flvPlayerRef.current?.buffered.length > 0) {

          let end = flvPlayerRef.current?.buffered?.end(0); //获取当前buffered值(缓冲区末尾)
          let delta = end - flvPlayerRef.current.currentTime; //获取buffered与当前播放位置的差值
          // 延迟过大，通过跳帧的方式更新视频
          if (delta > 10 || delta < 0) {
            console.log('跳帧:' + delta)
            flvPlayerRef.current.currentTime = flvPlayerRef.current?.buffered?.end(0) - 1;
            return;
          }


          // 追帧
          // if (delta > 1) {
          //   videoElementRef.current.playbackRate = 1.1;
          //   console.log('追帧:' + delta)
          // } else {
          //   videoElementRef.current.playbackRate = 1;
          // }
        }
      });

      flvPlayerRef.current.on(flvjs.Events.ERROR, (e, detail, info) => {
        // destroy
        console.log(e, detail, info)
        destroy()

        setTimeout(function () {
          init()
          console.log('初始化完成')
        }, 500)
      });

      // 视频断流
      flvPlayerRef.current.on("statistics_info", (res) => {
        console.log(lastDecodedFramesRef.current + ":" + res.decodedFrames)
        if (lastDecodedFramesRef.current === 0) { lastDecodedFramesRef.current = res.decodedFrames; return }
        if (lastDecodedFramesRef.current !== res.decodedFrames) {
          countNum.current = 0
          lastDecodedFramesRef.current = res.decodedFrames
        } else {
          console.log(lastDecodedFramesRef.current + ":" + res.decodedFrames + ":" + countNum.current)
          if (countNum.current > 5) {
            lastDecodedFramesRef.current = 0
            countNum.current = 0
            destroy()
            setTimeout(() => { init() }, 500)
          } else {
            countNum.current += 1
          }
        }
      });
    } else {
      console.error('FLV.js is not supported in this browser.');
    }
  }

  const destroy = () => {
    if (flvPlayerRef.current) {
      flvPlayerRef.current?.pause();
      flvPlayerRef.current?.unload();
      flvPlayerRef.current?.detachMediaElement();
      flvPlayerRef.current?.destroy();
      flvPlayerRef.current = null;
      console.log('销毁FLV')
    }
  }

  useEffect(() => {
    destroy()
    setTimeout(() => {
      if (props.liveUrl) {
        addressRef.current = props.liveUrl
        init()
      }
    }, 1000);

    // 网页重新激活后，更新视频
    window.onfocus = () => {
      if (flvPlayerRef.current?.buffered.length > 0) {
        let end = flvPlayerRef.current?.buffered?.end(0) - 1;
        flvPlayerRef.current.currentTime = end;
        flvPlayerRef.current.play()
      }
    };
    return () => {
      destroy()
      console.log('退出了flv直播')
    }

    // eslint-disable-next-line
  }, [props.liveUrl]); // 依赖 src，以便在 src 变化时重新创建播放器

  return (
    <>
      {/* <video ref={videoRef} className='radius8' width="100%" height="100%" controls muted /> */}
      <video id="videoElementRef.current" className='radius8' width="100%" height="100%" controls muted />
    </>

  )
}
export default FlvVideo;